import moment from 'moment';

export const getPeriod = (dateString) => {
  const d = moment(dateString);
  return d.format('MMM-YYYY')
}

export const localDate = (dateString) => {
  const d = moment(dateString);
  return d.format('DD/MM/YYYY')
}

export const inputDate = (dateObj) => {
  const d = dateObj ? moment(dateObj) : moment();
  return d.format('YYYY-MM-DD')
}

export const localInputDate = (dateObj) => {
  const d = moment(dateObj);
  return d.format('DD/MM/YYYY')
}



// WEBPACK FOOTER //
// ./src/_helpers/date.js